export default __webpack_public_path__ + "static/media/google.bb49f97a.png";